<div class="exercise-answer-review">
    <ng-container *ngIf="reviews.length; else emptyTemplate">
        <div class="exercise-answer-review__question" *ngFor="let review of reviews">
            <div class="exercise-answer-review__header">
                <span class="exercise-answer-review__title">{{ review.title || ('words.untitled' | translate) }}</span>
                <span class="exercise-answer-review__score" *ngIf="review.display !== 'unanswered'">
                    <span class="exercise-answer-review__ratio" *ngIf="review.ratioPercent !== null">{{ review.ratioPercent }}%</span>
                    <i class="icon"
                        [ngClass]="review.isCorrect ? 'icon-checkmark exercise-answer-review__icon--correct' : 'icon-close exercise-answer-review__icon--incorrect'"></i>
                </span>
            </div>

            <ng-container [ngSwitch]="review.display">
                <div class="exercise-answer-review__binary" *ngSwitchCase="'binary'">
                    <div class="exercise-answer-review__cell">
                        <span class="exercise-answer-review__label">{{ 'word.correct-answer' | translate }}</span>
                        <span>{{ review.correctLabel }}</span>
                    </div>
                    <div class="exercise-answer-review__cell">
                        <span class="exercise-answer-review__label">{{ 'correction.learner-answer' | translate }}</span>
                        <span>{{ review.studentLabel }}</span>
                    </div>
                </div>

                <ul class="exercise-answer-review__rows" *ngSwitchCase="'rows'">
                    <li class="exercise-answer-review__row" *ngFor="let row of review.rows">
                        <ng-container *ngIf="row.isCorrectOption !== undefined; else comparisonRow">
                            <i class="icon"
                                [ngClass]="{
                                    'icon-checkmark-square': row.isSelected,
                                    'icon-minus': !row.isSelected,
                                    'exercise-answer-review__icon--correct': row.isChoiceCorrect,
                                    'exercise-answer-review__icon--incorrect': row.isChoiceCorrect === false
                                }"></i>
                            <span [class.exercise-answer-review__missed-label]="row.isCorrectOption && !row.isSelected">{{ row.label }}</span>
                        </ng-container>
                        <ng-template #comparisonRow>
                            <div class="exercise-answer-review__pair">
                                <span class="exercise-answer-review__pair-label" *ngIf="row.label">{{ row.label }}</span>
                                <span class="exercise-answer-review__cell">
                                    <span class="exercise-answer-review__label">{{ 'word.correct-answer' | translate }}</span>
                                    <span>{{ row.correctText }}</span>
                                </span>
                                <span class="exercise-answer-review__cell">
                                    <span class="exercise-answer-review__label">{{ 'correction.learner-answer' | translate }}</span>
                                    <span>{{ row.studentText || '—' }}</span>
                                </span>
                                <i class="icon" [ngClass]="row.isChoiceCorrect ? 'icon-checkmark exercise-answer-review__icon--correct' : 'icon-close exercise-answer-review__icon--incorrect'"></i>
                            </div>
                        </ng-template>
                    </li>
                </ul>

                <div class="exercise-answer-review__text" *ngSwitchCase="'text'">
                    <span class="exercise-answer-review__label">{{ 'correction.learner-answer' | translate }}</span>
                    <p>{{ review.studentText || ('common.empty' | translate) }}</p>
                </div>

                <div class="exercise-answer-review__unanswered" *ngSwitchCase="'unanswered'">
                    <span>{{ 'common.empty' | translate }}</span>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-template #emptyTemplate>
        <msc-common-empty [message]="'common.empty' | translate">
            <ng-template></ng-template>
        </msc-common-empty>
    </ng-template>
</div>
